import datapoints from '../datapoints';
import setInboxRuleDiagnosticRequestStatus from './helpers/setInboxRuleDiagnosticRequestStatus';
import getOutlookMigrationDiagnosticsService from '../services/getOutlookMigrationDiagnosticsService';
import InboxRuleRequestStatus from '../store/schema/InboxRuleRequestStatus';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { action } from 'satcheljs/lib/legacy';
import { InboxRulesListOptionState } from '../store/schema/InboxRulesListOptionState';

export interface GenerateInboxRulesDiagnosticReportState {
    optionState: InboxRulesListOptionState;
}
/**
 * Generates an inbox rule diagnostic report
 */
export default action(
    'generateInboxRulesDiagnosticReport',
    datapoints.generateInboxRulesDiagnosticReportDatapoint
)(function generateInboxRulesDiagnosticReport(state?: GenerateInboxRulesDiagnosticReportState) {
    setInboxRuleDiagnosticRequestStatus(InboxRuleRequestStatus.Pending);
    let dataPoint = returnTopExecutingActionDatapoint();
    return getOutlookMigrationDiagnosticsService()
        .then(response => {
            if (response) {
                setInboxRuleDiagnosticRequestStatus(InboxRuleRequestStatus.Complete);
            } else {
                dataPoint.endWithError(
                    DatapointStatus.ServerError,
                    new Error('GetOutlookMigrationDiagnostics service request failed')
                );
                setInboxRuleDiagnosticRequestStatus(InboxRuleRequestStatus.Error);
            }
        })
        .catch(error => {
            dataPoint.endWithError(DatapointStatus.ServerError, error.message);
            setInboxRuleDiagnosticRequestStatus(InboxRuleRequestStatus.Error);
        });
});
